module.exports = __webpack_public_path__ + "static/media/mmm-headset.c5f35e69.svg";